module.exports = __webpack_public_path__ + "static/media/raina-sharma.968b95a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/Reviewers/raina-sharma.jpg
// module id = 1700
// module chunks = 0